import { ArrowLeft, ChevronRight, Home } from 'lucide-react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useFolderBreadcrumb } from '@/hooks/useCasoFolders';
import { Button } from '@/components/ui/button';

export function FolderBreadcrumb() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const folderId = searchParams.get('folder');
  const { data: breadcrumb = [], isLoading } = useFolderBreadcrumb(folderId);

  if (!folderId || isLoading) return null;

  // Calcula a pasta pai: se tiver mais de 1 item no breadcrumb, pega o penúltimo; senão, vai para raiz
  const parentFolderId = breadcrumb.length > 1 ? breadcrumb[breadcrumb.length - 2].id : null;

  const handleBack = () => {
    if (parentFolderId) {
      navigate(`/casos?folder=${parentFolderId}`);
    } else {
      navigate('/casos');
    }
  };

  return (
    <nav className="flex items-center gap-2 text-sm mb-4">
      <Button
        variant="ghost"
        size="icon"
        onClick={handleBack}
        className="h-8 w-8"
        title="Voltar para pasta anterior"
      >
        <ArrowLeft className="h-4 w-4" />
      </Button>
      <Link to="/casos" className="flex items-center gap-1 hover:text-primary transition-colors">
        <Home className="h-4 w-4" />
        <span>Casos / Clientes</span>
      </Link>

      {breadcrumb.map((item, index) => (
        <div key={item.id} className="flex items-center gap-2">
          <ChevronRight className="h-4 w-4 text-muted-foreground" />
          {index === breadcrumb.length - 1 ? (
            <span className="font-medium">{item.name}</span>
          ) : (
            <Link
              to={`/casos?folder=${item.id}`}
              className="hover:text-primary transition-colors"
            >
              {item.name}
            </Link>
          )}
        </div>
      ))}
    </nav>
  );
}
